// extracted by mini-css-extract-plugin
export default {"laptopHeader":"main-header_laptopHeader__uole+","tabletHeader":"main-header_tabletHeader__4sZju"};